module.exports = __webpack_public_path__ + "img/problem_mirro.937bf58f.svg";